import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseRoutes, ConditionalContentRoutes } from '@core/constants/routes.const';
import { AppState } from '@core/store';
import { selectCurrentConsultant } from '@core/store/consultant';
import { Store } from '@ngrx/store';
import { ProductUtilService } from '@shared/utils/product-util.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-header-offers',
  templateUrl: './header-offers.component.html',
  styleUrls: ['./header-offers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderOffersComponent implements OnInit {
  readonly Routes = {
    CustomerSpecialOffers: BaseRoutes.CustomerSpecialOffers,
    HostessSpecialOffers: ConditionalContentRoutes.HostessSpecialOffers,
  };

  mxWholeSale$!: Observable<boolean>;

  constructor(
    private store$: Store<AppState>,
    public productUtilService: ProductUtilService,
  ) {}

  ngOnInit(): void {
    this.mxWholeSale$ = this.store$
      .select(selectCurrentConsultant)
      .pipe(map((consultant) => !!consultant?.mxWholeSale));
  }
}
